import React from "react";
import Bear from "./Bear";
import Biker from "./Biker";
import Boy from "./Boy";
import Dinosaur from "./Dinosaur";
import CoolBoy from "../Assets/avatars/temp_avatars/Cool Boy.png";
import InquisitiveGirl from "../Assets/avatars/temp_avatars/Inquisitive Girl.png";
import MalayPrince from "../Assets/avatars/temp_avatars/Malay Prince.png";
import PeachGirl from "../Assets/avatars/temp_avatars/Peach Girl.png";

export interface IAvatar {
  icon: "bear" | "biker" | "boy" | "dino";
  active: boolean;
  large?: boolean;
  pulsate?: boolean;
  onClick?: () => void;
}

export default function Avatar(props: IAvatar) {
  return (
    <div className={`relative ${props.large ? "w-full h-full" : "w-8 h-8"}`}>
      {props.pulsate && (
        <div className="bg-brij-Gold absolute -inset-1 row-start-1 col-start-1 rounded-full animate-pulse" />
      )}
      <div
        onClick={props.onClick}
        // className={`${
        //   props.active && "border-4 border-brij-Red"
        // } absolute inset-0 p-2 rounded-full bg-brij-SkyBlue shadow-md row-start-1 col-start-1`}
        className={`absolute inset-0 overflow-clip rounded-full bg-brij-White shadow-md row-start-1 col-start-1 ${
          props.active && "border-4 border-brij-Black"
        }`}
      >
        {props.icon === "bear" && <img src={CoolBoy} />}
        {props.icon === "biker" && <img src={InquisitiveGirl} />}
        {props.icon === "boy" && <img src={MalayPrince} />}
        {props.icon === "dino" && <img src={PeachGirl} />}
      </div>
    </div>
  );
}
